import styled from 'styled-components';

export const StyledWrapper = styled.div`
  > div:not(:first-child) {
    margin-top: 20px;
  }

  .bulk-edit-balance-count,
  .bulk-edit-balance-list {
    .valid {
      color: #00c73c;
    }

    .invalid {
      color: #f5222d;
    }
  }

  .bulk-edit-balance-memo {
    width: 100%;
  }

  .bulk-edit-balance-count-wrap {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 700;
  }

  .bulk-edit-balance-count {
    display: flex;
    font-size: 16px;
    font-weight: 700;
  }
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  min-height: 90px;
`;

export const StyledNote = styled.span`
  color: #f5222d;
`;

export const StyledMemo = styled.p`
  margin: 10px 0;
  font-size: 18px;
  font-weight: bold;
`;

export const AnchorStyle = styled.a`
  color: #6200ea;
  text-decoration: underline;
  :hover {
    color: #6200ea;
    text-decoration: underline;
  }
`;

export const WarningTextStyle = styled.p`
  color: #ff0000;
`;
